import {License} from "../../const/license";
import {
    Feature,
    FEATURE_AUTOMATIONS,
    FEATURE_BASELINE,
    FEATURE_CRM,
    FEATURE_CUSTOM_STORY_POINTS,
    FEATURE_EXPENSES_MODULE,
    FEATURE_FINANCE_MODULE,
    FEATURE_GANTT_SNAPSHOT,
    FEATURE_SKILLS,
    FEATURE_USERS_CUSTOM_FIELDS,
    FEATURE_WORKLOAD,
    FeatureAccessRules
} from "./const";
import {LicenseType} from "../../license/license-proto";
// import {FEATURE_GANTT, FEATURE_GANTT_SNAPSHOT, FEATURE_SKILLS, FeatureAccessRules} from "./feature-access";

// Disable preset
const FREE_LICENSES = [License.FREE, License.FREE_15, License.FREE_25]

const FREE_AND_TRIAL = [
    License.FREE, License.FREE_15, License.FREE_25,
    License.TRIAL_PRO, License.TRIAL_PRO_14,License.TRIAL_PRO_21, License.TRIAL_PRO_30   // trials
]

// Allow presets
const BUSINESS_PLUS = [
    License.BUSINESS_2023, License.ENTERPRISE,
    License.PRO_PAY_PER_USER, License.PRO_FLAT_RATE_10_USERS, License.PRO_FLAT_RATE_15_USERS,
    License.PROFESSIONAL_OLD, License.PROFESSIONAL,

    License.TRIAL_PRO, License.TRIAL_PRO_14,License.TRIAL_PRO_21, License.TRIAL_PRO_30   // trials
]

const BUSINESS_PLUS_NEW = [
    License.BUSINESS_2023, License.ENTERPRISE,
    License.TRIAL_PRO, License.TRIAL_PRO_14,License.TRIAL_PRO_21, License.TRIAL_PRO_30   // trials
]

const ENTERPRISE = [
    License.ENTERPRISE
]

const TEST_ALL = BUSINESS_PLUS_NEW.concat(FREE_AND_TRIAL).concat([License.PROFESSIONAL_OLD])


export const FeatureAccessMatrix : { [key: string] : FeatureAccessRules }  = {

    [Feature.GOODDAY_API]: {
        'disabled'              : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [Feature.REPORTS]: {
        'disabled'              : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [Feature.FORMS]: {
        'disabled'              : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.EMAIL_REPLY]: {
        'disabled'              : FREE_AND_TRIAL,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.TIME_TRACKING]: {
        'disabled'              : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.GANTT]       : {
        'disabled'          : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [Feature.RECURRENCE]       : {
        'disabled'          : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [Feature.TWO_FA]       : {
        'enabled'               : BUSINESS_PLUS,
        // 'disabled'          : FREE_LICENSES
        requiredLicenseType     : LicenseType.Business
    },

    [FEATURE_WORKLOAD]       : {
        'enabled'           : BUSINESS_PLUS,
        // 'disabled'          : FREE_LICENSES
        requiredLicenseType     : LicenseType.Business
    },

    [FEATURE_GANTT_SNAPSHOT]  : {
        'enabled'               : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },

    [FEATURE_SKILLS] : {
        disabled        : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [FEATURE_USERS_CUSTOM_FIELDS] : {
        disabled        : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [FEATURE_AUTOMATIONS]   : {
        disabled        : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [FEATURE_FINANCE_MODULE] : {
        'enabled'               : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },

    [FEATURE_EXPENSES_MODULE] : {
        'enabled'               : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },

    [FEATURE_CUSTOM_STORY_POINTS]   : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },

    [FEATURE_CRM]   : {
        'enabled'               : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business,
    },

    [FEATURE_BASELINE]   : {
        enabled                 : BUSINESS_PLUS_NEW,
        requiredLicenseType     : LicenseType.Business
    },

    [Feature.SSO_SAML]   : {
        enabled                 : ENTERPRISE,
        requiredLicenseType     : LicenseType.Enterprise
    },

    [Feature.REPLY_RESTRICTIONS]   : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Enterprise
    },

    [Feature.TEAMS]   : {
        enabled                 : BUSINESS_PLUS_NEW,
        requiredLicenseType     : LicenseType.Business
    },

    [Feature.AI] : {
        enabled                 : BUSINESS_PLUS_NEW,
        requiredLicenseType     : LicenseType.Business
    },

    [Feature.CUSTOM_ENTITY]   : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Enterprise
    },

    [Feature.GIT_INTEGRATION] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.TRASH] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.VALIDATIONS] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.CHAT] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.MEETINGS] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.MAP] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.GOALS] : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },
    [Feature.ATTENDANCE] : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },
    [Feature.CUSTOM_TASK_ID] : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },
    [Feature.READ_ONLY] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.ACTIONS] : {
        disabled                : FREE_LICENSES,
        requiredLicenseType     : LicenseType.Pro
    },
    [Feature.SUPPORT_TICKET] : {
        enabled                 : BUSINESS_PLUS,
        requiredLicenseType     : LicenseType.Business
    },
}
